export const visit = (vm, at) => {
at({ "pt-br": { "purchaseMotions": { "pricingPageRedirect": { "button": { "defaultButtonCopy": "Visualizar pre\xE7os" } } } } });
};